import { ExpressionValue } from "../../ExpressionValue";
import { BaseLogicExpression } from "../Logic/BaseLogic";
import { StringDataDefinition } from "../../../Common/Data/Definitions/StringDataDefinition";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class StringIsEmptyExpression extends BaseLogicExpression {
    readonly __type: string = "String Is Empty";
    readonly __ruleName: string = "Is Empty";
    value1: ExpressionValue;

    constructor() {
        super();

        this.value1 = ExpressionValue.createExpressionValue(this, "stringValue", new StringDataDefinition());
    }

    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        return this.value1.evaluate(data, testContext) === "";
    }
}
